import { gql } from '../../../../../hooks'

export const DELETE_SUGGESTIONS = gql`
  mutation AdministrationDeleteAnalysisSuggestions($id: ID!) {
    aDelete(path: "analysis/suggestions", id: $id) {
    }
  }
`

export const LIST_SUGGESTIONS = gql`
  query AdministrationListAnalysisSuggestions(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "analysis/suggestions"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
